import InformationSectionPart1 from '../InformationSectionPart1';

const NewPolicyPage5Pluss = () => {
  return (
    <>
      <InformationSectionPart1 />
    </>
  );
};

export default NewPolicyPage5Pluss;
